import * as yup from 'yup';

export default yup.object({
  name: yup.string().required(),
  type: yup.string().required(),
});
